import React from "react";
import { RiMailSendFill } from "react-icons/ri";
import { BsGithub } from "react-icons/bs";
import { SlSocialTwitter } from "react-icons/sl";
import { AiFillLinkedin } from "react-icons/ai";
import { FaInstagramSquare } from "react-icons/fa";
import { send } from 'emailjs-com';
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";
function Touch() {
    const [toSend, setToSend] = useState({
    from_name: '',
    to_name: 'Lameck Meshack',
    message: '',
    reply_to: '',
  });

  const onSubmit = (e) => {
    e.preventDefault();
    send(
      'service_o1d2n0r',
      'template_69k4qeo',
      toSend,
      'E8-VrujyVTdJNgU70'
    )
      .then((response) => {
        // console.log('SUCCESS!', response.status, response.text);
        alert("Thank You!Lameck will get back to you")
      })
      .catch((err) => {
        alert("Something Went Wrong!Servers are down reach me +254718404999")
      });
      //reset the inputs
      setToSend({
        from_name: '',
        to_name: 'Lameck Meshack',
        message: '',
        reply_to: '',
      })

  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };
  return (
    <div id="contact" className="container">
      <h4>
        get in touch<span>!</span>
      </h4>
      <div className="touch-container">
      <div className="container touch-cont">
        <h3>Contact Info</h3>
        <p>
          <RiMailSendFill className="ic" />
          <span>otienolameck327@gmail.com</span>
        </p>
        <p>
          <BsGithub className="ic" />

          <span>
            Github:<a href="https://github.com/LameckMeshack" target="_blank" rel="noreferrer noopener" >Lameck_Meshack</a>{" "}
          </span>
        </p>
        <p>
          <SlSocialTwitter className="ic" />
          <span>
            Twitter:<a href="twitter.com" target="_blank" rel="noreferrer noopener" >Mac'Lameck</a>{" "}
          </span>
        </p>
        <p>
          <AiFillLinkedin className="ic" />

          <span>
            LinkedIn:<a href="https://www.linkedin.com/in/lameck-meshack-otieno-9944lam/" target="_blank" rel="noreferrer noopener" >Lameck Meshack</a>{" "}
          </span>
        </p>
        <p>
          <FaInstagramSquare className="ic" />
          <span>
            Instagram:<a href="instagram.com" target="_blank" rel="noreferrer noopener" >Mac'Lameck</a>{" "}
          </span>
        </p>
      </div>
      <div className="container touch-cont">
        <form onSubmit={onSubmit}>
        <h3>Send me a message</h3>
        <input type="text" placeholder="Your Name" name="from_name" value={toSend.from_name}
    onChange={handleChange} id="" />
        <input type="email" placeholder="Your Email" name="reply_to" value={toSend.reply_to}
    onChange={handleChange}  id="" />
        {/* <input type="text" placeholder="subject" name="subject"   id="" />? */}
        <textarea name="message" id="" cols="30" rows="3" value={toSend.message}
    onChange={handleChange} placeholder="Write Your Message"></textarea>
        <ReCAPTCHA 
        className="recaptcha"
       
        // sitekey={process.env.REACT_APP_SITE_KEY}
        sitekey="this is a test"
        
        />
        <button type="submit">Send Message</button>
        </form>
      </div>
      </div>
    </div>
  );
}

export default Touch;
